import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../AuthContext';
import NotificationContext from '../NotificationContext';

const Register = () => {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
        role: 'customer'
    });
    const { register } = useContext(AuthContext);
    const { showNotification } = useContext(NotificationContext);
    const navigate = useNavigate();

    const { username, email, password, role } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        try {
            const success = await register(username, email, password, role);
            if (success) {
                showNotification('Registration Successful!', 'success');
                navigate('/');
            }
        } catch (err) {
            console.error(err);
            showNotification('An error occurred during registration.', 'error');
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-image-container">
                {/* Replace with your image */}
                <img src="register-illustration.svg" alt="Register Illustration" />
            </div>
            <div className="auth-form-container">
                <div className="form-container">
                    <h1>Register</h1>
                    <form onSubmit={onSubmit}>
                        <div className="form-group">
                            <label className="form-label">Username</label>
                            <input
                                type="text"
                                placeholder="Username"
                                name="username"
                                value={username}
                                onChange={onChange}
                                className="form-control"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Email Address</label>
                            <input
                                type="email"
                                placeholder="Email Address"
                                name="email"
                                value={email}
                                onChange={onChange}
                                className="form-control"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Password</label>
                            <input
                                type="password"
                                placeholder="Password"
                                name="password"
                                value={password}
                                onChange={onChange}
                                minLength="6"
                                className="form-control"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Role</label>
                            <select name="role" value={role} onChange={onChange} className="form-control">
                                <option value="customer">Customer</option>
                                <option value="technician">Technician</option>
                            </select>
                        </div>
                        <input type="submit" value="Register" className="btn" />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Register;